import React, { useState, useEffect } from 'react';
import { search, getTerms, syllabiExist } from '../../../functions/Api';
import ClassAutocomplete from './ClassAutocomplete';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';

import { Button } from '@asu/unity-react-core';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ClassSearch(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const query = useQuery();
  const [errorMsg, setErrorMsg] = useState('');
  const [terms, setTerms] = useState(null);
  const [searchTerms, setSearchTerms] = useState({
    strm: query.get('strm') || '',
    subject: query.get('subject') || '',
    catalogNumber: query.get('catalogNumber') || '',
    classNumber: query.get('classNumber') || '',
    instructor: query.get('instructor') || '',
  });

  async function fetchTerms() {
    props.setLoading(true);
    let terms = await getTerms();
    // console.log(terms);
    setTerms(terms);
    setSearchTerms((prevState) => {
      var newTerms = {
        ...prevState,
        strm: query.get('strm') || terms.workingTerm,
      };
      return newTerms;
    });
    props.setLoading(false);
  }

  useEffect(() => {
    if (terms === null) {
      fetchTerms();
    }
  }, [terms]);

  const doSearch = async (params) => {
    props.setLoading(true);
    setErrorMsg('');

    try {
      let res = await search(params);
      if (!Array.isArray(res)) {
        res = [];
      }

      if (res.length === 0) {
        setErrorMsg('No classes found.');
      } else {
        res = await syllabiExist(res);
      }

      props.setClasses(res);
    } catch (err) {
      props.setClasses([]);
      if (err && err.data) {
        setErrorMsg(err.data);
      } else {
        setErrorMsg(
          'An error was encountered. Please try again or check back later.' +
            (err.message ? ' (' + err.message + ')' : '')
        );
      }
    }

    props.setLoading(false);
  };

  const submitHandler = async (event) => {
    // console.log(event.target.term.value);
    event.preventDefault();
    props.setSelectedClasses([]);
    if (searchTerms.subject === '' && searchTerms.catalogNumber !== '') {
      setErrorMsg(
        'Results cannot be found for your search. Please add additional criteria, like Subject, and try again.'
      );
    } else if (
      /\d+/.test(searchTerms.instructor) &&
      searchTerms.instructor.length !== 10
    ) {
      setErrorMsg('Invalid instructor emplid, please try again.');
    } else {
      // Update the URL with the current search terms
      const params = new URLSearchParams();
      Object.entries(searchTerms).forEach(([key, val]) => {
        if (val) params.set(key, val);
      });
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true }
      );
      doSearch(searchTerms);
    }
  };

  const changeHandler = (event) => {
    // console.log(event.target);
    let name = event.target.name;
    let val = event.target.value;
    setSearchTerms((prevState) => {
      // console.log({ ...prevState, [name]: val });
      return { ...prevState, [name]: val };
    });
  };

  const autocompleteOnSelect = (name, value) => {
    setSearchTerms((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  useEffect(() => {
    // If any search terms are present in the URL, perform a search on mount
    const hasAnySearch = Object.values(searchTerms).some((val) => val);
    if (hasAnySearch) {
      doSearch(searchTerms);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="class-search">
      <form
        className="row uds-form align-items-center"
        autoComplete="off"
        onSubmit={submitHandler}
      >
        <div className="form-group col-md-4 col-sm-12">
          <label>Term</label>
          <select
            className="form-select"
            style={{ height: '42px' }}
            id="term"
            name="strm"
            value={searchTerms.strm}
            onChange={changeHandler}
          >
            {terms &&
              terms.termsList.map((term) => (
                <option key={term.strm} value={term.strm}>
                  {term.description}
                </option>
              ))}
          </select>
        </div>
        <div className="form-group col-md-4 col-sm-12">
          <label htmlFor="subject">Subject</label>
          <input
            className="form-control"
            style={{ height: '42px' }}
            id="subject"
            type="text"
            name="subject"
            value={searchTerms.subject}
            onChange={changeHandler}
          />
        </div>
        <div className="form-group col-md-4 col-sm-12">
          <label htmlFor="catalogNumber">Catalog Number</label>
          <input
            className="form-control"
            style={{ height: '42px' }}
            id="catalogNumber"
            type="text"
            name="catalogNumber"
            value={searchTerms.catalogNumber}
            onChange={changeHandler}
          />
        </div>

        <div className="form-group col-md-4 col-sm-12">
          <label htmlFor="classNumber">Class Number</label>
          <input
            className="form-control"
            style={{ height: '42px' }}
            id="classNumber"
            type="text"
            name="classNumber"
            value={searchTerms.classNumber}
            onChange={changeHandler}
          />
        </div>
        <div className="form-group col-md-4 col-sm-12">
          <label htmlFor="instructor">Instructor</label>
          <input
            className="form-control"
            style={{ height: '42px' }}
            id="instructor"
            type="text"
            name="instructor"
            value={searchTerms.instructor}
            onChange={changeHandler}
          />
        </div>
        <div className="form-group col-md-4 col-sm-12">
          <label>&nbsp;</label>
          <br />
          <Button label="Search" color="gold" icon={['fas', 'search']} />
        </div>
      </form>
      <p className="error-msg">{errorMsg}</p>
    </div>
  );
}

export default ClassSearch;
